import React, { useState, useEffect } from "react"
import Block from "@bappweb/block"
import { useAppSelector } from "../../../config/hook"
import "../assets/style.scss"
import "../../../../../assets/styles/style.scss"
import "../../assets/style.scss"
import CampaignCarousel from "./campaignCarousel"
import Element from "@bappweb/element"
import { getConfigValue, isNullOrEmpty } from "@smpu-web/utils/utils"
import { getQueryStringWithParam } from "src/projects/ticarikredikarti/utils/utils"

const Notes = () => {
    const sessionData = useAppSelector((state) => state.sessionData.response)

    return (
        <Block type="section" className="notes-page-wrapper" id="landing-page-wrapper">
            <Block type="section" className="section general-features" dangerouslySetInnerHTML={{ __html: getConfigValue(sessionData?.configList, !isNullOrEmpty(getQueryStringWithParam("firm")) ? `TicariKrediKarti.Landing.CampaignText.Top.${getQueryStringWithParam("firm")}` : "TicariKrediKarti.Landing.CampaignText.Top") }} />
            <Block className="container section-info-container">
                <Element type="p" className="section-info-p">*Firma anlaşmalarına göre ticari kart kampanyaları değişiklik gösterebilir.</Element>
            </Block>

            <Block type="section" className="center-section">
                <Block type="section" className="section general-features" dangerouslySetInnerHTML={{ __html: getConfigValue(sessionData?.configList, "TicariKrediKarti.Landing.CampaignText.Carousel.Top") }} />
                <CampaignCarousel />
            </Block>

        </Block>
    )
}

export default Notes
